<template>
  <vx-tooltip :text="disabledHint()" :enabled="disabled" position="left">
    <div class="inline-flex w-full" :class="disabled ? 'bg-soft cursor-not-allowed' : 'hover:bg-primary section-picker-item'" @click="onClick" @mouseover="setHovered(true)" @mouseleave="setHovered(false)">
      <div class="flex m-3 p-3 rounded" :class="disabled ? 'bg-white' : 'bg-soft'">
        <img :src="iconPath" class="m-auto icon"/>
      </div>
      <span class="ml-2 my-auto text-base text-left">{{title}}</span>
    </div>
  </vx-tooltip>
</template>

<script>
import ctaIcon from '@/assets/images/icons/cta_icon.svg'
import ctaHover from '@/assets/images/icons/cta_hover.svg'
import ctaDisabled from '@/assets/images/icons/cta_disabled.svg'
import txtIcon from '@/assets/images/icons/txt_icon.svg'
import txtHover from '@/assets/images/icons/txt_hover.svg'
import txtDisabled from '@/assets/images/icons/txt_disabled.svg'
import qrIcon from '@/assets/images/icons/qr_icon.svg'
import qrHover from '@/assets/images/icons/qr_hover.svg'
import imgDisabled from '@/assets/images/icons/img_disabled.svg'
import imgIcon from '@/assets/images/icons/img_icon.svg'
import imgHover from '@/assets/images/icons/img_hover.svg'
import qrDisabled from '@/assets/images/icons/qr_disabled.svg'
import operatorStatusIcon from '@/assets/images/icons/operator_status_icon.svg'
import operatorStatusHover from '@/assets/images/icons/operator_status_hover.svg'
import dayIcon from '@/assets/images/icons/day_icon.svg'
import dayHover from '@/assets/images/icons/day_hover.svg'
import timeBetweenIcon from '@/assets/images/icons/time_between_icon.svg'
import timeBetweenHover from '@/assets/images/icons/time_between_hover.svg'
import channelIcon from '@/assets/images/icons/channel_icon_outline.svg'
import channelIconHover from '@/assets/images/icons/channel_icon_hover.svg'
import urlIcon from '@/assets/images/icons/url_icon.svg'
import urlIconHover from '@/assets/images/icons/url_icon_hover.svg'
import contextIcon from '@/assets/images/icons/context_icon.svg'
import contextIconHover from '@/assets/images/icons/context_icon_hover.svg'

export default {
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    disabled: { type: Boolean, required: true },
    disabledHint: { type: Function, required: true }
  },

  data() {
    return {
      isHovered: false
    }
  },

  methods: {
    onClick() {
      if(!this.disabled) this.$emit('click')
    },
    setHovered(hovered) {
      this.isHovered = hovered
    }
  },
  computed: {
    iconPath() {
      if(this.icon === 'cta') {
        if(this.disabled) return ctaDisabled
        if(this.isHovered) return ctaHover
        return ctaIcon
      }

      if(this.icon === 'txt') {
        if(this.disabled) return txtDisabled
        if(this.isHovered) return txtHover
        return txtIcon
      }

      if(this.icon === 'qr') {
        if(this.disabled) return qrDisabled
        if(this.isHovered) return qrHover
        return qrIcon
      }

      if(this.icon === 'img') {
        if(this.disabled) return imgDisabled
        if(this.isHovered) return imgHover
        return imgIcon
      }

      if(this.icon === 'operator') {
        return this.isHovered ? operatorStatusHover : operatorStatusIcon
      }

      if(this.icon === 'day') {
        return this.isHovered ? dayHover : dayIcon
      }

      if(this.icon === 'time-between') {
        return this.isHovered ? timeBetweenHover : timeBetweenIcon
      }

      if(this.icon === 'channel') {
        return this.isHovered ? channelIconHover : channelIcon
      }

      if(this.icon === 'url') {
        return this.isHovered ? urlIconHover : urlIcon
      }

      if(this.icon === 'context') {
        return this.isHovered ? contextIconHover : contextIcon
      }
    }
  }
}
</script>

<style scoped>

  .section-picker-item:hover, .section-picker-item:hover > div > i {
    color: white !important;
    cursor: pointer;
  }

  .section-picker-item:hover > div {
    background-color: theme('colors.primary-focus') !important;
  }

  .icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
</style>
